import {jsonMember, jsonObject} from "typedjson";

@jsonObject
export class DxUser {
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: true, isRequired: false})
  protected _id: number;

  @jsonMember({name: "login", constructor: String, emitDefaultValue: true, isRequired: false})
  protected _login: string;

  @jsonMember({name: "firstName", constructor: String, emitDefaultValue: true, isRequired: false})
  protected _firstName: string;

  @jsonMember({name: "lastName", constructor: String, emitDefaultValue: true, isRequired: false})
  protected _lastName: string;

  @jsonMember({name: "position", constructor: String, emitDefaultValue: true, isRequired: false})
  protected _position: string;


  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get login(): string {
    return this._login;
  }

  set login(value: string) {
    this._login = value;
  }

  get firstName(): string {
    return this._firstName;
  }

  set firstName(value: string) {
    this._firstName = value;
  }

  get lastName(): string {
    return this._lastName;
  }

  set lastName(value: string) {
    this._lastName = value;
  }

  get fullName(): string {
    return this._firstName + this._lastName;
  }

  get position(): string {
    return this._position;
  }

  set position(value: string) {
    this._position = value;
  }
}
